import { getCurrencySymbol } from '../src/getCurrencySymbol.ts';
export default getCurrencySymbol;
